import React from 'react';
import { useTranslation } from 'react-i18next';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useTheme } from '@mui/material/styles';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CopyNotification = ({ open, onClose }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  
  return (
    <Snackbar
      ContentProps={{
        style: {
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
        },
      }}
      open={open}
      autoHideDuration={1000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity="success">
        {t('notification.copied')}
      </Alert>
    </Snackbar>
  );
};

export default CopyNotification;
